import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { FilterProps } from "@/types/filters";

export const PriceRangeFilter = ({ value, onChange }: FilterProps) => {
  return (
    <Select value={value || "all"} onValueChange={onChange}>
      <SelectTrigger className="w-[180px]">
        <SelectValue placeholder="Price Range" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">Price Range</SelectItem>
        <SelectItem value="1">$</SelectItem>
        <SelectItem value="2">$$</SelectItem>
        <SelectItem value="3">$$$</SelectItem>
        <SelectItem value="4">$$$$</SelectItem>
      </SelectContent>
    </Select>
  );
};